import { render } from "./Content.vue?vue&type=template&id=c9454c4c&scoped=true"
import script from "./Content.vue?vue&type=script&lang=js"
export * from "./Content.vue?vue&type=script&lang=js"

import "./Content.vue?vue&type=style&index=0&id=c9454c4c&scoped=true&lang=css"

import exportComponent from "D:\\Shivani\\myProjects\\p2p_admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9454c4c"]])

export default __exports__